import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import RatingGraph from "./RatingGraph";
import { appLogger } from "../../utils";

const AnalyticsDetails = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "AnalyticsDetails",
      component: "mailing",
      fileName: "analyticsDetails.tsx",
      props: props,
    },
  });
  const { detailRow, rating, categoriesValue } = props;
  return (
    <Grid item xs={12}>
      <RatingGraph
        startupRatingData={rating && rating.startupRating}
        freazeRatingData={rating && rating.freezeRating}
        layerRatingData={rating && rating.layerRating}
        categoriesValue={categoriesValue}
        ticketArrival={detailRow.createdOn}
        userDetails={detailRow.userDetails}
      />
    </Grid>
  );
};

export default AnalyticsDetails;
